import { handleActions } from 'redux-actions';

import { ADMIN_APPLICATIONS, ADMIN_APPLICATION, ADMIN_JOBS, ADMIN_JOB } from '../../types';

import { baseReducer, createReducer } from '../utils';

const initialState = {
  selected_job: {
    ...baseReducer
  },
  selected_application: {
    ...baseReducer
  },
  jobs: {
    ...baseReducer
  },
  applications: {
    ...baseReducer
  }
};

const selected_job = createReducer(ADMIN_JOB, initialState, ['selected_job']);
const selected_application = createReducer(ADMIN_APPLICATION, initialState, ['selected_application']);
const jobs = createReducer(ADMIN_JOBS, initialState, ['jobs']);
const applications = createReducer(ADMIN_APPLICATIONS, initialState, ['applications']);

const admin_state = handleActions(
  {
    ...selected_job,
    ...selected_application,
    ...jobs,
    ...applications
  },
  initialState
);

export default admin_state;
